const OperationExtensionsMap: {
	[operationName: string]: unknown[] | undefined;
} = {};

export const startCapturingExtensions = (operationName: string) => {
	OperationExtensionsMap[operationName] = OperationExtensionsMap[operationName] || [];
};
export const stopCapturingExtensions = (operationName: string) => {
	OperationExtensionsMap[operationName] = undefined;
};
export const putExtensions = (operationName: string, extension: unknown) => {
	if (extension !== undefined) {
		const extensionsForOperation = OperationExtensionsMap[operationName];
		if (extensionsForOperation !== undefined) {
			extensionsForOperation.push(extension);
		}
	}
};

export const getExtensions = (operationName: string) => OperationExtensionsMap[operationName] || [];
